<div class="ui-tab w-100 h-100 flex-col gap-16">
    <mat-select [formControl]="entityTypes"
                multiple
                class="ui-selector entity-selector"
                [placeholder]="'DATABASE_TAGS.SELECT_PLACEHOLDERS'|translate">
        <mat-option *ngFor="let item of entityTypeLabels | keyvalue"
                    [value]="+item.key">
            {{ item.value | translate }}
        </mat-option>
    </mat-select>

    <ng-container *ngIf="entityTypes.value?.length">
        <div class="flex-row gap-8 start-center">
            <span class="ui-icon-cross c-p"
                  [matTooltip]="'COMMON.CLEAR_FILTERS'|translate"
                  (click)="cleanFilters()">
            </span>

            <ng-container *ngFor="let entityType of entityTypes.value">
                <ui-filter-chip [title]="entityTypeLabels[entityType] | translate"
                                (removeClicked)="cleanEntityTypesControl(entityType)">

                </ui-filter-chip>
            </ng-container>
        </div>
    </ng-container>

    <div class="h-100 min-h-0">
        <div class="h-100 min-h-0 flex-col">
            <ng-container *ngIf="!selectIsLoading(); else loader">
                <ng-container *ngIf="selectEntities()?.length && tableConfig(); else noDataResult">
                    <ui-dataset-table
                        [data]="selectEntities()"
                        [config]="tableConfig()!"
                        (loadMore)="onLoadMore()"
                        (rowAction)="onRowAction($event)"
                    ></ui-dataset-table>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #noDataResult>
    <ui-no-data [imgSrc]="noResults.imgSrc"
                [title]="noResults.title|translate">
    </ui-no-data>
</ng-template>

<!-- CELL TEMPLATES -->
<ng-template #nameCell let-row>
    <div uiTruncateText>{{ row.name }}</div>
</ng-template>

<ng-template #typeCell let-row>
    <div>{{ entityTypeLabels[row.entityType] | translate }}</div>
</ng-template>

<ng-template #loader>
    <ui-preloader [color]="loaderColor.blue"
                  style="padding: 100px 0;">
    </ui-preloader>
</ng-template>